import { useConcurso } from '../../../../providers/ConcursoProvider';
import { useCallback, useState, useRef } from 'react';
import { FormLabel, Table, Form as FormB } from 'react-bootstrap';
import styled from 'styled-components';
import {
  cleanMsg,
  postActoAdministrativo,
  useActoAdministrativo,
} from '../../../../appStore/actoAdministrativo';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import yupEs from '../../../../yup-es';
import { SuccessErrorDlg } from '../../../CompUtils/SuccessErrorDlg';
import { useHistory } from 'react-router';
import { finEtapa } from '../gestionConcursoSlice';
import FullLoading from '../../../CompUtils/FullLoading';
import AlertDialog from '../../../CompUtils/AlertDialog';
import Form from '../../../CompUtils/Form';
Yup.setLocale(yupEs);

const PaddingTd = styled.td`
  padding-right: 36px !important;
`;

/* const { Form } = createFormCtx(); */
export const TablaActoAdministrativo = () => {
  const { idLlamadoConcurso } = useConcurso();
  const history = useHistory();
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    nroExpediente: '',
    fpublicacionBora: '',
    linkActoAdm: '',
  });
  const [expediente, setExpediente] = useState<any>();

  const { loading, error, success } = useActoAdministrativo();
  const [confirmation, setConfirmation] = useState(false);
  const handleSubmit = () => {
    if (!confirmation) {
      setConfirmation(true);
      return;
    }
    setConfirmation(false);
    dispatch(postActoAdministrativo({ idLlamadoConcurso, ...values, expediente }));
  };

  return (
    <Form onSubmit={handleSubmit} submitText="Confirmar" btns={['submit']}>
      <Table className="mt-3 mb-3 justify-content-center align-items-center" striped bordered hover>
        <tbody>
          <tr>
            <td valign="middle" className="text-center">
              Proyecto de Acto Administrativo
            </td>
            <td align="center">
              <FormB.Control
                value={values.nroExpediente}
                onChange={(e) => {
                  setValues({ ...values, nroExpediente: e.target.value });
                }}
                //validate={Yup.string().required()}
                placeholder="Ingrese expediente"
                id="nroExpedienteBora"
              />
            </td>
            <PaddingTd className="text-center">
              <FormB.Group>
                <FormB.Label>Expediente</FormB.Label>
                <FormB.File
                  accept=".pdf,.doc"
                  name="expediente"
                  type="file"
                  onChange={(ev: any) => {
                    setExpediente(ev.currentTarget.files[0]);
                  }}
                  //validate={Yup.string().required()}
                  id="expediente"
                />
                <FormB.File.Label data-browse="Cargar archivo">{expediente.name}</FormB.File.Label>
              </FormB.Group>
            </PaddingTd>
          </tr>
          <tr>
            <td className="text-center">Publicación BORA</td>
            <PaddingTd className="text-center" colSpan={2}>
              <FormB.Control
                type="date"
                value={values.fpublicacionBora}
                onChange={(e) => {
                  setValues({ ...values, fpublicacionBora: e.target.value });
                }}
                //validate={Yup.string().required()}
                id="fpublicacionBora"
              />
            </PaddingTd>
          </tr>
          <tr>
            <td className="text-center">Acto Administrativo</td>
            <PaddingTd className="text-center" colSpan={2}>
              <FormB.Control
                value={values.linkActoAdm}
                onChange={(e) => {
                  setValues({ ...values, linkActoAdm: e.target.value });
                }}
                //validate={Yup.string().required()}
                id="linkActoAdm"
                placeholder="Ingrese Link BORA"
              />
            </PaddingTd>
          </tr>
        </tbody>
      </Table>
      <FullLoading show={loading} />
      <AlertDialog
        icon="question"
        title="Concursar"
        subtitle="El concurso se enviará al Coordinador Concursal designado para su publicación. ¿Está seguro que desea continuar?"
        onClose={(wasAccepted) => {
          if (wasAccepted) handleSubmit();
          else setConfirmation(false);
        }}
        show={confirmation}
      />
      <SuccessErrorDlg
        success={success}
        error={error}
        onClose={() => {
          dispatch(cleanMsg());

          if (success) {
            dispatch(finEtapa());
            history.replace('/concursos');
          }
        }}
      />
    </Form>
  );
};
